import { readAuthSession } from "./authSession.mjs";

const parsePositiveInt = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  const normalized = Math.trunc(parsed);
  return normalized > 0 ? normalized : null;
};

// H3 PR 2: the user id comes from the session marker (or a legacy pre-H3 token), never from the cookie JWT.
export const parseCurrentUserIdFromToken = (storage = globalThis?.localStorage) =>
  parsePositiveInt(readAuthSession(storage)?.userId);

export const resolveCurrentUserId = async (axiosClient) => {
  const fallbackUserId = parseCurrentUserIdFromToken();
  if (!axiosClient || typeof axiosClient.get !== "function") {
    return fallbackUserId;
  }
  try {
    const { data } = await axiosClient.get("/me");
    return parsePositiveInt(data?.id) || fallbackUserId;
  } catch (_) {
    return fallbackUserId;
  }
};
